import React, { PureComponent } from "react";
import DownIcon from "mdi-react/ChevronDownIcon";
import { Collapse } from "reactstrap";
import TopbarMenuLink from "./TopbarMenuLink";
import { signout } from "../../../redux/middlewares/authMIddleware";
import { connect } from "react-redux";

const Ava = `${process.env.PUBLIC_URL}/img/ava.png`;

class TopbarProfile extends PureComponent {
  constructor() {
    super();
    this.state = {
      collapse: false
    };
  }

  toggle = () => {
    this.setState(prevState => ({ collapse: !prevState.collapse }));
  };

  render() {
    const { collapse } = this.state;
    const { user } = this.props;

    return (
      <div className="topbar__profile">
        <button type="button" className="topbar__avatar" onClick={this.toggle}>
          <img
            className="topbar__avatar-img"
            src={user?.photoURL || Ava}
            alt="avatar"
          />
          <p className="topbar__avatar-name"> {user?.displayName} </p>
          <DownIcon className="topbar__icon" />
        </button>
        {collapse && (
          <button
            type="button"
            className="topbar__back"
            onClick={this.toggle}
          />
        )}
        <Collapse isOpen={collapse} className="topbar__menu-wrap">
          <div className="topbar__menu">
            {/* <TopbarMenuLink title="Page one" icon="list" path="/pages/one" /> */}
            {user?.admin == true && (
              <>
                <TopbarMenuLink
                  title="Account"
                  icon="inbox"
                  path="/user/account"
                  onClick={() => this.toggle()}
                />
                <div className="topbar__menu-divider" />
              </>
            )}
            <TopbarMenuLink
              title="Log Out"
              icon="exit"
              path="/"
              onClick={() => this.props.signout()}
            />
          </div>
        </Collapse>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log({ state: state.authReducer.user });
  return {
    user: state.authReducer.user
    // error: state.authReducer.error
  };
};

export default connect(mapStateToProps, { signout })(TopbarProfile);
